import moment from "moment";
import _ from 'lodash';

export const AppointmentSlotStatus = {
  REGISTRATION: "REGISTRATION",
  ADMITTED: "ADMITTED",
  TREATMENT: "TREATMENT",
  DISCHARGED: "DISCHARGED",
  DEPARTED: "DEPARTED",
  WAITING: "WAITING",
  PENDING: "PENDING",
  TRANSFERRED: "TRANSFERRED",
  CANCELLED: "CANCELLED",
  DELETED: "DELETED",
};

export function generateAvailableHours(parsedDate, session, slots) {
  const sessSlots =  session.daySlots?.[parsedDate.format('YYYY_MM_DD')];
  let allSlots = _.unionWith(slots,sessSlots , (arrVal, othVal) => {
    return arrVal.startDate.isSame(othVal.startDate) && arrVal.assignedSession === othVal.assignedSession;
  });
  let availableSlots = _.filter(allSlots, s => {return !s.patientId && s.status !== 'locked'});
  return _.map(availableSlots, s => { return s.startDate.toISOString(); });
}

export function generateAssignableSlots(date, session, slots) {
  const availableHours = generateAvailableHours(date, session, slots);

  return availableHours.map((hour) => {
    return {
      startDate: hour,
      endDate: moment(hour)
        .add(session.slotDurationInMinutes, "minute")
        .toISOString(),
      status: AppointmentSlotStatus.PENDING,
    };
  });
}
